import React from 'react';
import { Formik } from 'formik';
import { ModalWithStyles } from './ModalWithStyles';
import Axios from '../../../common/axiosInterceptor';
import cookie from 'react-cookies';

export function DeleteBlockedNumbersModal({
  setRefetchToggleForBlockedNumbers,
  enqueueSnackbarWithStyles,
  userAtom,
  selected,
  handleClose,
  show,
}) {
  return (
    <Formik
      onSubmit={async (values, actions) => {
        if (values.selected.length) {
          for (let i = 0; i < values.selected.length; i++) {
            const data = JSON.stringify({
              businessid: userAtom.contents?.businessid,
              apikey: userAtom.contents?.apikey,
              number: values.selected[i].number,
            });
            const url = `${process.env.VITE_APP_API_DOMAIN}/${process.env.VITE_APP_API_STAGE}/blockedNumbers/numbers`;
            const accessToken = cookie.load('accessToken');
            await Axios({
              method: 'DELETE',
              url,
              headers: {
                authorization: accessToken,
              },
              data,
            });
          }
        }
        handleClose();
        setRefetchToggleForBlockedNumbers({});
        enqueueSnackbarWithStyles({
          message: `Successfully Deleted ${values.selected.length} Blocked Number(s)`,
          alertProps: { severity: 'success' },
        });
        actions.resetForm({});
      }}
      enableReinitialize={true}
      initialValues={{
        selected: selected ?? [],
      }}
    >
      {(formik) => (
        <>
          <form
            className="form form-label-right"
            onSubmit={formik.handleSubmit}
            noValidate
          >
            <ModalWithStyles
              onSubmit={formik.handleSubmit}
              title="Delete Blocked Number(s)"
              aria-labelledby="example-modal-sizes-title-md"
              show={show}
              onHide={handleClose}
              isSubmitting={formik.isSubmitting}
              isLoading={formik.isSubmitting}
              deleteDialog={true}
              size="xs"
            >
              <p>
                You are about to delete {formik.values.selected.length} selected
                Blocked Number(s), this procedure is not reversible.
              </p>
              <p>Do you want to proceed?</p>
            </ModalWithStyles>
          </form>
        </>
      )}
    </Formik>
  );
}
